import { Property } from '@arrived/models';

import { Mapbox } from '../../Mapbox';

interface PropertyLocationMapProps {
  property: Property;
}

export const PropertyLocationMap = ({ property }: PropertyLocationMapProps) => {
  const { lat, lon } = property.address || {};

  if (lat == null || lon == null) {
    return null;
  }

  return (
    <Mapbox lat={lat} long={lon} markers={[{ lat, long: lon }]} zoom={12} height="350px" width="100%" marker="home" />
  );
};
